export const dashboard = {
  dashboard: {
    detailedStatistics: 'Detailed Statistics',
    hideSlidingPanel: 'Hide Statistics',
    hideSlidingPanelAll: 'Hide Statistics: All Streams',
    resetStatistics: 'Reset Statistics',
    showSlidingPanel: 'Show Statistics',
    showSlidingPanelAll: 'Show Statistics: All Streams',
    hideAudioChannels: 'Hide Audio Channels',
    showAudioChannels: 'Show Audio Channels',
    title: 'Dashboard',
    audio: {
      header: 'Audio Encoders',
      hoverText: {
        muted: 'Muted',
        failed: 'Failed',
      },
      title: 'AUDIO ENCODING',
    },
    deviceStatus: {
      activeInput: 'Active Input',
      emsStatus: 'Haivision Services',
      firmware: 'Firmware',
      serialNumber: 'Serial Number',
      personality: 'Personality',
      systemUptime: 'System Uptime',
      title: 'DEVICE STATUS',
      storage: 'Storage',
    },
    metadata: 'Metadata',
    scte: 'Ad Insertion',
    statistics: {
      bitrate: 'BR',
      bitrateExplain: 'Bitrate (Send Rate)',
      dropped: 'DP',
      droppedExplain: 'Dropped Packets',
      latency: 'LAT',
      latencyExplain: 'Latency',
      rtt: 'RTT',
      rttExplain: 'Round-Trip Time',
    },
    video: {
      encoding: 'Encoding',
      inUse: 'In Use',
      scaling: 'Scaling',
      title: 'VIDEO ENCODING',
      videoEncoder: 'Video Encoder',
      videoEncoders: 'Video Encoders',
    },
  },
};
